// import { Paper } from "@mui/material";
import Paper from "@mui/material/Paper";
import StandardCardProps from "./AppCard.props";
import { useCardStyles } from "./AppCard.styles";
import React from "react";

export default function Card({
  children,
  elevation = 3,
  className = "",
  style = {},
}: StandardCardProps) {
  const CardStyles = useCardStyles(style);
  return (
    <Paper
      className={`${CardStyles.standard}  ${className}`}
      elevation={elevation}
      style={{ backgroundColor: "#000000", borderRadius: 0 }}
    >
      {children}
    </Paper>
  );
}
